module.exports = __webpack_public_path__ + "img/DSVA_RAW_LOGO-02.59bf5444.png";